import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import intlShape from '@/shared/utils/intlShape';
import api from '@/shared/api';
import config from '@/config';
import CanRead from '@/shared/components/security/CanRead';
import messages from '../relationOverviewMessages';

export default class UpdateRelationTeamModal extends Component {
  state = {
    action: 'add',
    selectedValue: null,
    availableTeams: null,
  };
  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  componentDidMount() {
    this.retrieveTeams();
  }

  retrieveTeams = () => {
    api.base.get(`${config.appUrls.api}/api/team/MyTeams`).then(({ data }) => {
      this.setState({ availableTeams: data });
    });
  };

  actionChanged = event => {
    const action = event.target.value;
    this.setState({
      action,
    });
  };

  selectedValueChanged = event => {
    const teamId = event.target.value;

    this.setState(state => ({
      ...state,
      selectedValue: teamId,
    }));
  };

  isFormInvalid = () => {
    const { action, selectedValue } = this.state;
    if (!action || !selectedValue) return true;

    return false;
  };

  onSave = () => {
    const { action, selectedValue } = this.state;
    const { onSave } = this.props;

    return onSave({ action, teamId: selectedValue });
  };

  closeModal = () => {
    const { onClose } = this.props;

    this.setState(state => ({
      ...state,
      selectedValue: null,
    }));

    onClose();
  };

  render() {
    const { show, intl } = this.props;
    const { action, availableTeams, selectedValue } = this.state;

    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.AddOrRemoveTeams)}
        show={show}
        onClose={this.closeModal}
        disabled={this.isFormInvalid()}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          {availableTeams && availableTeams.length > 0 ? (
            <div>
              <div className="form-group">
                <label className="control-label col-md-3">
                  <FormattedMessage {...messages.Action} />
                </label>
                <div className="col-md-9">
                  <select onChange={this.actionChanged} className="form-control" value={action}>
                    <option value="add">{intl.formatMessage(messages.AddTeam)}</option>
                    <option value="remove">{intl.formatMessage(messages.RemoveTeam)}</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label className="control-label col-md-3">
                  <FormattedMessage {...messages.Team} />
                </label>
                <div className="col-md-9">
                  <select
                    onChange={this.selectedValueChanged}
                    className="form-control"
                    value={selectedValue || ''}
                  >
                    {!selectedValue && (
                      <option value="">{intl.formatMessage(messages.SelectATeam)}</option>
                    )}
                    {availableTeams.map(team => (
                      <option key={team.id} value={team.id}>
                        {team.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          ) : (
            <div className="alert alert-warning">
              <p>{intl.formatMessage(messages.UpdateRelationTeamNotInATeam)}</p>
              <CanRead on="settings">
                <p>
                  <a target="_blank" href="/#/settings/teams">
                    {intl.formatMessage(messages.ClickHereToGoToTeamSettings)}
                  </a>
                </p>
              </CanRead>
            </div>
          )}
        </div>
      </OkCancelModal>
    );
  }
}
